import { useState } from 'react';
import { FaEye, FaEyeSlash } from '../Icons';
import { ControllerTextField, ControllerTextFieldProps, IconButton } from '../../';

export type ControllerPasswordFieldProps = Omit<ControllerTextFieldProps, 'type'> & {
  type?: 'text' | 'password';
};

export const ControllerPasswordField = function (props: ControllerPasswordFieldProps) {
  const { type, sx, InputProps, ...textFieldProps } = props;

  const [showPass, setShowPass] = useState(type !== 'password');

  const handleShowPassToggle = () => {
    setShowPass(!showPass);
  };

  const showIcon = (
    <IconButton
      onClick={handleShowPassToggle}
      title='show'
      sx={{
        '&:hover': {
          cursor: 'pointer',
        },
      }}
    >
      <FaEye />
    </IconButton>
  );

  const hideIcon = (
    <IconButton
      onClick={handleShowPassToggle}
      title='hide'
      sx={{
        '&:hover': {
          cursor: 'pointer',
        },
      }}
    >
      <FaEyeSlash />
    </IconButton>
  );

  return (
    <ControllerTextField
      type={showPass ? 'text' : 'password'}
      InputProps={{
        ...InputProps,
        endAdornment: showPass ? hideIcon : showIcon,
      }}
      {...textFieldProps}
    />
  );
};

ControllerPasswordField.displayName = 'ControllerPasswordField';
